import React, { useEffect, useState } from "react";
import "./index.scss";
import { SaveCardListService } from "../../services/AdminService";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import { SaveCardPlaceholder } from "../skeleton-placeholder";
import CardModal from "./CardModal";

const SaveCardList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [savedCardList, setSavedCardList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [cardItemData, setCardItemData] = useState();
    const [modalType, setModalType] = useState("");

    const getSaveCardList = async () => {
        setIsLoading(true);
        await SaveCardListService("", (res) => {
            if (res.status === 200) {
                // console.log("Save card list Data==>", res.data);
                const { paymentMethods } = res.data;
                setSavedCardList(paymentMethods);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
            setIsLoading(false);
        });
    }

    const handleCardButton = (item, type) => {
        setCardItemData(item);
        setShowModal(true);
        setModalType(type);
    }

    useEffect(() => {
        getSaveCardList();
    }, []);

    return (
        <>
            <div className="saved-payment-card">
                {isLoading ? (
                    <div className="saved-card-list last-item-margin-0">
                        <SaveCardPlaceholder number={3} />
                    </div>
                ) : (
                    <>
                        {savedCardList?.data?.length > 0 ? (
                            <div className="saved-card-list last-item-margin-0">
                                {savedCardList?.data?.map((item, index) => {
                                    return (
                                        <div key={item.id} className="card-block saved-card-item">
                                            <div className="saved-card-type">
                                                <PaymentIcon type={item.card.brand} format="flatRounded" width={44} />
                                            </div>
                                            <div className="saved-card-info">
                                                <p><span className="text-capitalize">{item.card.brand}</span> ending in {item.card.last4}</p>
                                                <p className="saved-card-date">Exp. {item.card.exp_month}/{item.card.exp_year}</p>
                                            </div>
                                            <div className="default-actions">
                                                {savedCardList?.customer?.invoice_settings?.default_payment_method === item?.id ? (
                                                    <span className="btn-default">Default</span>
                                                ) : (
                                                    <span className="btn-default cursor-pointer" onClick={() => handleCardButton(item, "default")}>Set as default</span>
                                                )}
                                                <button className="bi bi-trash3-fill btn text-danger ms-3" onClick={() => handleCardButton(item, "delete")}></button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <p>No cards available.</p>
                        )}
                    </>
                )}
            </div>
            <CardModal
                modalType={modalType}
                showModal={showModal}
                setShowModal={setShowModal}
                cardData={cardItemData}
                listFnc={() => getSaveCardList()}
            />
        </>
    );
};

export default SaveCardList;

